import axios from "../../../../api/axios";
import { TransactionStatusEnum } from "../../enums/payment";

import {
  PaymentTransactionsResponse,
  TransactionsResponse,
  PaymentTransactionDetailsResponse,
  InvoiceDetailsResponse,
} from "../types/transactions.types";

export const getTransactions = async (limit: number, offset: number): Promise<PaymentTransactionsResponse> => {
  try {
    const response = await axios.get<PaymentTransactionsResponse>(
      `/api/payment/transactions?limit=${limit}&offset=${offset}`
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch transactions");
  }
};

export const getInvoices = async (
  userId: number,
  limit: number,
  offset: number,
  status: TransactionStatusEnum | null
): Promise<TransactionsResponse> => {
  try {
    const response = await axios.get<TransactionsResponse>(
      `/users/${userId}/payment-transactions?limit=${limit}&offset=${offset}${status ? `&status=${status}` : ""}`
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch invoices");
  }
};

export const getPaymentTransactionDetails = async (
  transactionId: number
): Promise<PaymentTransactionDetailsResponse> => {
  try {
    const response = await axios.get<PaymentTransactionDetailsResponse>(`/payment-transactions/${transactionId}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch payment transaction details");
  }
};

export const getWalletTransactionDetails = async (
  transactionId: number
): Promise<PaymentTransactionDetailsResponse> => {
  try {
    const response = await axios.get<PaymentTransactionDetailsResponse>(`/api/wallets/transactions/${transactionId}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch wallet transaction details");
  }
};

export const getInvoiceDetails = async (invoiceId: number): Promise<InvoiceDetailsResponse> => {
  try {
    const response = await axios.get<InvoiceDetailsResponse>(`/api/payment/link/transactions/${invoiceId}/invoice`);
    return response.data;
  } catch (err) {
    throw new Error(err + " | Failed to fetch invoice details");
  }
};
